// Entry point for the v2 planner (Konva canvas + Stimulus UI).
// Loaded by the v2 planner views (plans/edit_v2 + plans/new_v2).

import { Application } from '@hotwired/stimulus';
import PlannerController from './planner2/planner_controller';
import FeedbackController from './controllers/feedback_controller';
import NavToggleController from './controllers/nav_toggle_controller';
import SearchController from './controllers/search_controller';
import PlannerVersionSwitchController from './controllers/planner_version_switch_controller';

const app = Application.start();
app.register('planner', PlannerController);
app.register('feedback', FeedbackController);   // feedback widget (layout + nav)
app.register('nav-toggle', NavToggleController); // site header mobile menu
app.register('search', SearchController);        // site header plant search
app.register('planner-version-switch', PlannerVersionSwitchController);
